import http from '@/utils/http';
const endpoint = 'facility-icons';

export default {
    async init(facility_id, no_loader) {
        const config = no_loader ? { headers: { 'no-loader': true } } : {};
        const response = await http.get(`${endpoint}/init/${facility_id}`, config);
        return response
    },
    async getIcons(facility_id, no_loader) {
        const config = no_loader ? { headers: { 'no-loader': true } } : {};
        const response = await http.get(`${endpoint}/list/${facility_id}`, config);
        return response.data;
    },
    async saveIcons(facility_links, no_loader) {
        const config = no_loader ? { headers: { 'no-loader': true } } : {};
        const response = await http.post(`${endpoint}/store`, facility_links, config);
        return response.data;
    }
}
